import React from 'react'
import PropTypes from 'prop-types'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {ConnectedRouter} from 'connected-react-router'
import {ConfigProvider} from 'antd'
import en from 'antd/lib/locale-provider/en_GB'
import moment from 'moment'
import {history} from './Utils/utils'
import InitComponent from './Containers/InitComponent'
import {loadStripe} from '@stripe/stripe-js'
import {Elements} from '@stripe/react-stripe-js'
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'moment/locale/en-gb' // important!

import './index.less'
import './App.less'
import './Components/Forms/Form.less';
import './Containers/LoginPage/styles.less'

/*production_test stripe*/
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
  locale: 'en'
})

moment.updateLocale('en-gb', {
  weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  monthsShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
})

function App({store}) {
  return (
    <Elements stripe={stripePromise}>
      <Provider store={store.store}>
        <PersistGate loading={null} persistor={store.persistor}>
          <ConfigProvider locale={en}>
            <ConnectedRouter history={history}>
              <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <InitComponent/>
              </GoogleOAuthProvider>
            </ConnectedRouter>
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </Elements>
  )
}

App.propTypes = {
  store: PropTypes.shape({
    store: PropTypes.object,
    persistor: PropTypes.object,
  }).isRequired,
}

export default App
